<section class="fixed-height parallaxBg bg-img" data-bg="assets/img/fondo5.jpg" style="background-image: url('assets/img/fondo5.jpg')">
  <div class="container h-100">
    <div class="row align-items-center h-100">
      <div class="col-lg-7 text-center m-auto">
        <div class="about-us-content white mt-100">
          <h3 style="color: white">
            INMUEBLES RELIGIOSOS
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="welcome-section pt-80 pt-pd-60 pt-40" style="background-image: url('/assets/img/fondo-tomo11.png'); background-size: cover;
background-position: center;">
  <div class="container">
    <div class="row">
      <!-- Start Section title -->
      <div class="col-lg-8 m-auto text-center">
        <div class="section-title-wrap">
          <h2>Consulta de Fichas de inmuebles religiosos</h2>
          <p class="mb-0" style="font-weight: 300;">A continuación, se muestra la lista de los inmuebles religiosos
            catalogados del Centro Histórico de Cusco, en los cuales podremos encontrar su información arquitectonica y arqueológica,
            dividas en fichas de catalogación.
          </p>
        </div>
      </div><!-- End Section title -->
    </div>
  </div>
</section>
<div class="page-wrapper" style="background-image: url('/assets/img/fondo-leyenda-catalogacion.png'); background-size: cover; background-position: center;">
  <div class="accordion-content-wrapper mt-10 mt-md-10 mt-sm-10 mb-120 mb-md-80 mb-sm-60">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 m-auto">
          <!-- Start Accordion Element #01 -->
          <div class="accordion-element-1">
            <div class="restaurant-why-us-accordion" id="accordionOne">
              <!-- Start Accordion item #01 -->
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h3 data-toggle="collapse" data-target="#domingo" style="color:white">
                    <span>01.</span> SANTO DOMINGO
                  </h3>
                </div>
                <div id="domingo" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                          <table class="table">
                              <tbody>
                                <tr>
                                  <th scope="row">1</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/ficha/FICHA ARQUITECTONICA SANTO DOMINGO.pdf" target="_blank"> FICHA ARQUITECTÓNICA SANTO DOMINGO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">2</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/ficha/Copia de FICHA ARQUITECTONICA SANTO DOMINGO (el modificado).pdf" target="_blank"> FICHA ARQUITECTÓNICA SANTO DOMINGO MODIFICADO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">3</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arqueologica/ficha/Copia de FICHA ARQUEOLOGICA 1-PLANO.pdf" target="_blank"> FICHA ARQUEOLÓGICA - PLANO SANTO DOMINGO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">4</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arqueologica/ficha/FICHA ARQUEOLOGICA 2-FACHADA ORIGINAL.pdf" target="_blank"> FICHA ARQUEOLÓGICA - FACHADA ORIGINAL SANTO DOMINGO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">5</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arqueologica/ficha/FICHA ARQUEOLOGICA 3-FACHADA REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - FACHADA REUTILIZADOS SANTO DOMINGO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">6</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arqueologica/ficha/FICHA ARQUEOLOGICA 4-INTERIOR ORIGINAL.pdf" target="_blank"> FICHA ARQUEOLÓGICA - INTERIOR ORIGINAL SANTO DOMINGO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">7</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arqueologica/ficha/FICHA ARQUEOLOGICA 5-INTERIOR REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - INTERIOR REUTILIZADOS SANTO DOMINGO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">8</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 1 SANTO DOMINGO-CONJUNTO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 1 - SANTO DOMINGO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">9</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 2 SANTO DOMINGO-IMAFRONTE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 2 - SANTO DOMINGO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">10</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 3 SANTO DOMINGO-FRONTISPICIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 3 - SANTO DOMINGO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">11</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 5 SANTO DOMINGO-TORRE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 4 - SANTO DOMINGO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">12</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 6 SANTO DOMINGO-CUPULAS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 5 - SANTO DOMINGO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">13</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7 SANTO DOMINGO-NAVE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 6 - SANTO DOMINGO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">14</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-1 SANTO DOMINGO -NAVE EPISTOLA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 7 - SANTO DOMINGO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">15</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-2 SANTO DOMINGO- NAVE EVANGELIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 8 - SANTO DOMINGO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">16</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-5 SANTO DOMINGO - CORO Y SOTOCORO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 9 - SANTO DOMINGO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">17</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9 SANTO DOMINGO 1°CLAUSTRO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 10 - SANTO DOMINGO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">18</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9-1 SANTO DOMINGO 1°CLAUSTRO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 11 - SANTO DOMINGO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">19</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9-2 SANTO DOMINGO - GALERIA 1° CLAUSTRO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 12 - SANTO DOMINGO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">20</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9-3 SANTO DOMINGO - GALERIA 1° CLAUSTRO LIENZOS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 13 - SANTO DOMINGO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">21</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 10 SANTO DOMINGO - 2° CLAUSTRO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 14 - SANTO DOMINGO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">22</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 13 SANTO DOMINGO - RECIBO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 15 - SANTO DOMINGO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">23</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 14 SANTO DOMINGO - PROFUNDIS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 16 - SANTO DOMINGO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">24</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 17 SANTO DOMINGO - ANTIGUA SACRISTIA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 17 - SANTO DOMINGO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">25</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arqueologica/fotografica/FICHA FOTOGRAFICA 1.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 1 - SANTO DOMINGO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">26</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arqueologica/fotografica/FICHA FOTOGRAFICA 2.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 2 - SANTO DOMINGO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">27</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arqueologica/fotografica/FICHA FOTOGRAFICA 3.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 3 - SANTO DOMINGO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">28</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arqueologica/fotografica/FICHA FOTOGRAFICA 4.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 4 - SANTO DOMINGO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">29</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arqueologica/fotografica/FICHA FOTOGRAFICA 5.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 5 - SANTO DOMINGO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">30</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arqueologica/fotografica/FICHA FOTOGRAFICA 6.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 6 - SANTO DOMINGO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">31</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arqueologica/fotografica/FICHA FOTOGRAFICA 7.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 7 - SANTO DOMINGO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">32</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arqueologica/fotografica/FICHA FOTOGRAFICA 8.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 8 - SANTO DOMINGO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">33</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arqueologica/fotografica/FICHA FOTOGRAFICA 9.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 9 - SANTO DOMINGO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">34</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arqueologica/fotografica/FICHA FOTOGRAFICA 10.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 10 - SANTO DOMINGO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">35</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arqueologica/fotografica/FICHA FOTOGRAFICA 11.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 11 - SANTO DOMINGO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">36</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arqueologica/fotografica/FICHA FOTOGRAFICA 12.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 12 - SANTO DOMINGO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">37</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/arqueologica/fotografica/FICHA FOTOGRAFICA 13.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 13 - SANTO DOMINGO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">38</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santo-domingo/historia/ficha arte. Santo Domingo.pdf" target="_blank"> FICHA HISTÓRICA - SANTO DOMINGO</a></td>
                                </tr>
                              </tbody>
                            </table>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h3 data-toggle="collapse" data-target="#ana" style="color:white">
                    <span>02.</span> Santa Ana
                  </h3>
                </div>
                <div id="ana" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                          <table class="table">
                              <tbody>
                                <tr>
                                  <th scope="row">1</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arquitectonica/ficha/FICHA ARQUITECTONICA SANTA ANA.pdf" target="_blank"> FICHA ARQUITECTÓNICA SANTA ANA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">2</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arqueologica/ficha/FICHA ARQUEOLOGICA 1-PLANO.pdf" target="_blank"> FICHA ARQUEOLÓGICA - PLANO SANTA ANA</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">3</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arqueologica/ficha/FICHA ARQUEOLOGICA 2-FACHADA REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - FACHADA REUTILIZADOS SANTA ANA</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">4</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arqueologica/ficha/FICHA ARQUEOLOGICA 3-INTERIOR REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - INTERIOR REUTILIZADOS SANTA ANA</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">5</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arqueologica/ficha/FICHA ARQUEOLOGICA 4-INTERIOR ORIGINAL.pdf" target="_blank"> FICHA ARQUEOLÓGICA - INTERIOR ORIGINAL SANTA ANA</a></td>
                                </tr>

                                <tr>
                                  <th scope="row">6</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arquitectonica/fotografica/FICHA FOTOGRÁFICA 1 SANTA ANA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 1 - SANTA ANA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">7</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arquitectonica/fotografica/FICHA FOTOGRÁFICA 2 SANTA ANA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 2 - SANTA ANA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">8</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arquitectonica/fotografica/FICHA FOTOGRÁFICA 3 SANTA ANA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 3 - SANTA ANA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">9</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arquitectonica/fotografica/FICHA FOTOGRÁFICA 5 SANTA ANA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 4 - SANTA ANA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">10</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7.1 SANTA ANA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 5 - SANTA ANA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">11</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7.2 SANTA ANA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 6 - SANTA ANA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">12</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7.3 SANTA ANA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 7 - SANTA ANA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">13</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arquitectonica/fotografica/FICHA FOTOGRÁFICA 8 -SANTA ANA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 8 - SANTA ANA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">14</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arquitectonica/fotografica/FICHA FOTOGRÁFICA 17 SANTA ANA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 9 - SANTA ANA </a></td>
                                </tr>

                                <tr>
                                  <th scope="row">15</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arqueologica/fotografica/FICHA FOTOGRAFICA 1.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 1 - SANTA ANA</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">16</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arqueologica/fotografica/FICHA FOTOGRAFICA 2.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 2 - SANTA ANA</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">17</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arqueologica/fotografica/FICHA FOTOGRAFICA 3.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 3 - SANTA ANA</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">18</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arqueologica/fotografica/FICHA FOTOGRAFICA 4.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 4 - SANTA ANA</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">19</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/arqueologica/fotografica/FICHA FOTOGRAFICA 5.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 5 - SANTA ANA</a></td>
                                </tr>

                                <tr>
                                  <th scope="row">20</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-ana/historia/Ficha de Arte San Juan De Dios.pdf" target="_blank"> FICHA HISTÓRICA - SANTA ANA</a></td>
                                </tr>
                              </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Start Accordion item #02 -->
              <div class="card">
                <div class="card-header" id="headingTwo">
                  <h3 data-toggle="collapse" data-target="#edu" style="color:white">
                    <span>03.</span>EDUCANDAS
                  </h3>
                </div>
                <div id="edu" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                          <table class="table">
                              <tbody>
                                <tr>
                                  <th scope="row">1</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-juan-de-dios/arquitectonica/ficha/FICHA ARQUITECTONICA EDUCANDAS.pdf" target="_blank"> FICHA ARQUITECTÓNICA EDUCANDAS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">2</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-juan-de-dios/arqueologica/ficha/FICHA ARQUEOLOGICA 1-PLANO.pdf" target="_blank"> FICHA ARQUEOLÓGICA - PLANO EDUCANDAS</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">3</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-juan-de-dios/arqueologica/ficha/FICHA ARQUEOLOGICA 2-FACHADA REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - FACHADA REUTILIZADOS EDUCANDAS</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">4</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-juan-de-dios/arqueologica/ficha/FICHA ARQUEOLOGICA 3-INTERIOR REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - INTERIOR REUTILIZADOS EDUCANDAS</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">5</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-juan-de-dios/arqueologica/ficha/FICHA ARQUEOLOGICA 4-INTERIOR ORIGINAL.pdf" target="_blank"> FICHA ARQUEOLÓGICA - INTERIOR ORIGINAL EDUCANDAS</a></td>
                                </tr>

                                <tr>
                                  <th scope="row">6</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-juan-de-dios/arquitectonica/fotografica/FICHA FOTOGRÁFICA 1 EDUCANDAS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 1 - EDUCANDAS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">7</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-juan-de-dios/arquitectonica/fotografica/FICHA FOTOGRÁFICA 2 EDUCANDAS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 2 - EDUCANDAS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">8</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/ssan-juan-de-dios/arquitectonica/fotografica/FICHA FOTOGRÁFICA 3 EDUCANDAS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 3 - EDUCANDAS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">9</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-juan-de-dios/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7 EDUCANDAS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 4 - EDUCANDAS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">10</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-juan-de-dios/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9 EDUCANDAS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 5 - EDUCANDAS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">11</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-juan-de-dios/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9.1 EDUCANDAS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 6 - EDUCANDAS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">12</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-juan-de-dios/arquitectonica/fotografica/FICHA FOTOGRÁFICA 10 EDUCANDAS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 7 - EDUCANDAS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">13</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-juan-de-dios/arquitectonica/fotografica/FICHA FOTOGRÁFICA 10.1 EDUCANDAS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 8 - EDUCANDAS </a></td>
                                </tr>


                                <tr>
                                  <th scope="row">14</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-juan-de-dios/arqueologica/fotografica/FICHA FOTOGRAFICA 1.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 1 - EDUCANDAS</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">15</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-juan-de-dios/arqueologica/fotografica/FICHA FOTOGRAFICA 2.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 2 - EDUCANDAS</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">16</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-juan-de-dios/arqueologica/fotografica/FICHA FOTOGRAFICA 3.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 3 - EDUCANDAS</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">17</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-juan-de-dios/arqueologica/fotografica/FICHA FOTOGRAFICA 4.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 4 - EDUCANDAS</a></td>
                                </tr>


                                <tr>
                                  <th scope="row">18</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-juan-de-dios/historia/Ficha de Arte San Juan De Dios.pdf" target="_blank"> FICHA HISTÓRICA - EDUCANDAS</a></td>
                                </tr>
                              </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Start Accordion item #03 -->
              <div class="card">
                <div class="card-header" id="headingThree">
                  <h3 data-toggle="collapse" data-target="#francisco" style="color:white">
                    <span>04.</span> SAN FRANCISCO
                  </h3>
                </div>
                <div id="francisco" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                          <table class="table">
                              <tbody>
                                <tr>
                                  <th scope="row">1</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/ficha/FICHA ARQUITECTONICA SAN CRISTOBAL.pdf" target="_blank"> FICHA ARQUITECTÓNICA SAN CRISTOBAL </a></td>
                                </tr>

                                <tr>
                                  <th scope="row">2</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 1 SAN CRISTOBAL-CONJUNTO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 1 - SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">3</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 3 SAN CRISTOBAL-FRONTISPICIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 2 - SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">4</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/ssan-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 5 SAN CRISTOBAL-TORRE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 3 - SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">5</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7 SAN CRISTOBAL-NAVE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 4 - SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">6</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-1 SAN CRISTOBAL-MURO DE LA EPISTOLA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 5 - SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">7</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-2 SAN CRISTOBAL-CORO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 6 - SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">8</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 8 SAN CRISTOBAL-SACRISTIA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 7 - SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">9</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 17 SAN CRISTOBAL-CAPILLA SAN CRISTOBAL.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 8 - SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">10</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 18 SAN CRISTOBAL-CAPILLA SR. DE LA CAIDA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 9 - SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">11</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 19 SAN CRISTOBAL-SR. DE LA FORTALEZA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 10 - SAN CRISTOBAL </a></td>
                                </tr>
                              </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Start Accordion item #04 -->
              <div class="card">
                <div class="card-header" id="headingFour">
                  <h3 data-toggle="collapse" data-target="#clara" style="color:white">
                    <span>05.</span> SANTA CLARA
                  </h3>
                </div>
                <div id="clara" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <div class="col-12">
                      <table class="table">
                          <tbody>
                            <tr>
                              <th scope="row">1</th>
                              <td><a href="assets/pdf/inmuebles-religiosos/santa-clara/arqueologica/ficha/FICHA ARQUEOLOGICA 1-PLANO.pdf" target="_blank"> FICHA ARQUEOLÓGICA - PLANO SANTA CLARA</a></td>
                            </tr>
                            <tr>
                              <th scope="row">2</th>
                              <td><a href="assets/pdf/inmuebles-religiosos/santa-clara/arqueologica/ficha/FICHA ARQUEOLOGICA 2-FACHADA REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - FACHADA REUTILIZADOS SANTA CLARA</a></td>
                            </tr>

                            <tr>
                              <th scope="row">3</th>
                              <td><a href="assets/pdf/inmuebles-religiosos/santa-clara/arqueologica/fotografica/FICHA FOTOGRAFICA 1.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 1 - SANTA CLARA</a></td>
                            </tr>
                            <tr>
                              <th scope="row">4</th>
                              <td><a href="assets/pdf/inmuebles-religiosos/santa-clara/arqueologica/fotografica/FICHA FOTOGRAFICA 2.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 2 - SANTA CLARA</a></td>
                            </tr>
                            <tr>
                              <th scope="row">5</th>
                              <td><a href="assets/pdf/inmuebles-religiosos/santa-clara/arqueologica/fotografica/FICHA FOTOGRAFICA 3.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 3 - SANTA CLARA</a></td>
                            </tr>
                            <tr>
                              <th scope="row">6</th>
                              <td><a href="assets/pdf/inmuebles-religiosos/santa-clara/arqueologica/fotografica/FICHA FOTOGRAFICA 4.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 4 - SANTA CLARA</a></td>
                            </tr>
                          </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#jesus" style="color:white">
                    <span>06.</span> COMPAÑIA DE JESUS
                  </h3>
                </div>
                <div id="jesus" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                          <table class="table">
                              <tbody>
                                <tr>
                                  <th scope="row">1</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/compania-de-jesus/arquitectonica/ficha/FICHA ARQUITECTONICA COMPAÑIA DE JESUS.pdf" target="_blank"> FICHA ARQUITECTÓNICA COMPAÑIA DE JESUS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">2</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/compania-de-jesus/arqueologica/ficha/FICHA ARQUEOLOGICA 1-PLANO.pdf" target="_blank"> FICHA ARQUEOLÓGICA - PLANO COMPAÑIA DE JESUS</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">3</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/compania-de-jesus/arqueologica/ficha/FICHA ARQUEOLOGICA 2-FACHADA REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - FACHADA REUTILIZADOS COMPAÑIA DE JESUS</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">4</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/compania-de-jesus/arqueologica/ficha/FICHA ARQUEOLOGICA 3-INTERIOR REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - INTERIOR REUTILIZADOS COMPAÑIA DE JESUS</a></td>
                                </tr>


                                <tr>
                                  <th scope="row">5</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/compania-de-jesus/arquitectonica/fotografica/FICHA FOTOGRÁFICA 1 COMP.DE JESUS-CONJUNTO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 1 - COMPAÑIA DE JESUS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">6</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/compania-de-jesus/arquitectonica/fotografica/FICHA FOTOGRÁFICA 2 COMPAÑIA DE JESUS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 2 - COMPAÑIA DE JESUS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">7</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/compania-de-jesus/arquitectonica/fotografica/FICHA FOTOGRÁFICA 4 COMP.DE JESUS-PORTADA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 3 - COMPAÑIA DE JESUS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">8</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/compania-de-jesus/arquitectonica/fotografica/FICHA FOTOGRÁFICA 4-1 COMP.DE JESUS-PORTADA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 4 - COMPAÑIA DE JESUS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">9</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/compania-de-jesus/arquitectonica/fotografica/FICHA FOTOGRÁFICA 4-2 COMP.DE JESUS-PORTADA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 5 - COMPAÑIA DE JESUS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">10</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/compania-de-jesus/arquitectonica/fotografica/FICHA FOTOGRÁFICA 5 COMPAÑIA DE JESUS-TORRES.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 6 - COMPAÑIA DE JESUS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">11</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/compania-de-jesus/arquitectonica/fotografica/FICHA FOTOGRÁFICA 6 COMPAÑIA DE JESUS-COBERTURA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 7 - COMPAÑIA DE JESUS </a></td>
                                </tr>



                                <tr>
                                  <th scope="row">12</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/compania-de-jesus/arqueologica/fotografica/FICHA FOTOGRAFICA 1.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 1 - COMPAÑIA DE JESUS</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">13</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/compania-de-jesus/arqueologica/fotografica/FICHA FOTOGRAFICA 2.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 2 - COMPAÑIA DE JESUS</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">14</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/compania-de-jesus/arqueologica/fotografica/FICHA FOTOGRAFICA 3.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 3 - COMPAÑIA DE JESUS</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">15</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/compania-de-jesus/arqueologica/fotografica/FICHA FOTOGRAFICA 4.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 4 - COMPAÑIA DE JESUS</a></td>
                                </tr>


                                <tr>
                                  <th scope="row">16</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/compania-de-jesus/historia/Compañia de Jesus.pdf" target="_blank"> FICHA HISTÓRICA - COMPAÑIA DE JESUS</a></td>
                                </tr>
                              </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#jesuita" style="color:white">
                    <span>07.</span> CONVENTO JESUITA
                  </h3>
                </div>
                <div id="jesuita" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                          <table class="table">
                              <tbody>
                                <tr>
                                  <th scope="row">1</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/convento-jesuita/arquitectonica/ficha/FICHA ARQUITECTONICA CONVENTO JESUITA.pdf" target="_blank"> FICHA ARQUITECTÓNICA CONVENTO JESUITA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">2</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/convento-jesuita/arqueologica/ficha/FICHA ARQUEOLOGICA 1-PLANO.pdf" target="_blank"> FICHA ARQUEOLÓGICA - PLANO CONVENTO JESUITA</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">3</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/convento-jesuita/arqueologica/ficha/FICHA ARQUEOLOGICA 2-FACHADA REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - FACHADA REUTILIZADOS CONVENTO JESUITA</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">4</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/convento-jesuita/arqueologica/ficha/FICHA ARQUEOLOGICA 3-INTERIOR REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - INTERIOR REUTILIZADOS CONVENTO JESUITA</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">5</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/convento-jesuita/arqueologica/ficha/FICHA ARQUEOLOGICA 4-INTERIOR ORIGINAL.pdf" target="_blank"> FICHA ARQUEOLÓGICA - INTERIOR ORIGINAL CONVENTO JESUITA</a></td>
                                </tr>

                                <tr>
                                  <th scope="row">6</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/convento-jesuita/arquitectonica/fotografica/FICHA FOTOGRÁFICA 1 CONVENTO JESUITA-CONJUNTO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 1 - CONVENTO JESUITA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">7</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/convento-jesuita/arquitectonica/fotografica/FICHA FOTOGRÁFICA 4 CONVENTO JESUITA- 1PORTADA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 2 - CONVENTO JESUITA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">8</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/sconvento-jesuita/arquitectonica/fotografica/FICHA FOTOGRÁFICA 4-1 CONVENTO JESUITA- 2PORTADA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 3 - CONVENTO JESUITA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">9</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/convento-jesuita/arquitectonica/fotografica/FICHA FOTOGRÁFICA 6 CONVENTO JESUITA-CUBIERTA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 4 - CONVENTO JESUITA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">10</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/convento-jesuita/arquitectonica/fotografica/FICHA FOTOGRÁFICA 8 CONVENTO JESUITA-ANTIGUA SACRISTIA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 5 - CONVENTO JESUITA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">11</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/convento-jesuita/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9 CONVENTO JESUITA-CLAUSTRO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 6 - CONVENTO JESUITA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">12</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/convento-jesuita/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9-1 CONVENTO JESUITA-GALERIAS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 7 - CONVENTO JESUITA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">13</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/convento-jesuita/arquitectonica/fotografica/FICHA FOTOGRÁFICA 13 -CONVENTO JESUITA-VESTIBULO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 8 - CONVENTO JESUITA </a></td>
                                </tr>

                                <tr>
                                  <th scope="row">14</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/convento-jesuita/arqueologica/fotografica/FICHA FOTOGRAFICA 1.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 1 - CONVENTO JESUITA</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">15</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/convento-jesuita/arqueologica/fotografica/FICHA FOTOGRAFICA 2.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 2 - CONVENTO JESUITA</a></td>
                                </tr>
                              </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#siete" style="color:white">
                    <span>08.</span> CAPILLA DE NUESTRA SEÑORA DE LORETO
                  </h3>
                </div>
                <div id="siete" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                          <table class="table">
                              <tbody>
                                <tr>
                                  <th scope="row">1</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/capilla-nuestra-senora-de-loreto/arqueologica/ficha/FICHA ARQUEOLOGICA 1-PLANO.pdf" target="_blank"> FICHA ARQUEOLÓGICA - PLANO CAPILLA DE NUESTRA SEÑORA DE LORETO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">2</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/capilla-nuestra-senora-de-loreto/arqueologica/ficha/FICHA ARQUEOLOGICA 2-FACHADA REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - FACHADA REUTILIZADOS CAPILLA DE NUESTRA SEÑORA DE LORETO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">3</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/capilla-nuestra-senora-de-loreto/arqueologica/ficha/FICHA ARQUEOLOGICA 3-INTERIOR REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - INTERIOR REUTILIZADOS CAPILLA DE NUESTRA SEÑORA DE LORETO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">4</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/capilla-nuestra-senora-de-loreto/arqueologica/fotografica/FICHA FOTOGRAFICA 1.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 1 - CAPILLA DE NUESTRA SEÑORA DE LORETO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">5</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/capilla-nuestra-senora-de-loreto/arqueologica/fotografica/FICHA FOTOGRAFICA 2.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 2 - CAPILLA DE NUESTRA SEÑORA DE LORETO</a></td>
                                </tr>
                              </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#ignacio" style="color:white">
                    <span>09.</span> CAPILLA DE SAN IGNACIO
                  </h3>
                </div>
                <div id="ignacio" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                          <table class="table">
                              <tbody>
                                <tr>
                                  <th scope="row">1</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/capilla-san-ignacio-de-loyola/arquitectonica/ficha/FICHA ARQUITECTONICA CAPILLA DE SAN IGNACIO.pdf" target="_blank"> FICHA ARQUITECTÓNICA CAPILLA DE SAN IGNACIO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">2</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/capilla-san-ignacio-de-loyola/arqueologica/ficha/FICHA ARQUEOLOGICA 1-PLANO.pdf" target="_blank"> FICHA ARQUEOLÓGICA - PLANO CAPILLA DE SAN IGNACIO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">3</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/capilla-san-ignacio-de-loyola/arqueologica/ficha/FICHA ARQUEOLOGICA 2-FACHADA REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - FACHADA REUTILIZADOS CAPILLA DE SAN IGNACIO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">4</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/capilla-san-ignacio-de-loyola/arqueologica/ficha/FICHA ARQUEOLOGICA 3-INTERIOR REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - INTERIOR REUTILIZADOS CAPILLA DE SAN IGNACIO</a></td>
                                </tr>


                                <tr>
                                  <th scope="row">5</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/capilla-san-ignacio-de-loyola/arquitectonica/fotografica/FICHA FOTOGRÁFICA 1 CAP. DE SAN IGNACIO - CONJUNTO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 1 - CAPILLA DE SAN IGNACIO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">6</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/capilla-san-ignacio-de-loyola/arquitectonica/fotografica/FICHA FOTOGRÁFICA 4 CAP. DE SAN IGNACIO-PORTADA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 2 - CAPILLA DE SAN IGNACIO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">7</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/capilla-san-ignacio-de-loyola/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7 CAP. DE SAN IGNACIO - NAVE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 3 - CAPILLA DE SAN IGNACIO </a></td>
                                </tr>


                                <tr>
                                  <th scope="row">8</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/capilla-san-ignacio-de-loyola/arqueologica/fotografica/FICHA FOTOGRAFICA 1.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 1 - CAPILLA DE SAN IGNACIO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">9</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/capilla-san-ignacio-de-loyola/arqueologica/fotografica/FICHA FOTOGRAFICA 2.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 2 - CAPILLA DE SAN IGNACIO</a></td>
                                </tr>


                                <tr>
                                  <th scope="row">10</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/capilla-san-ignacio-de-loyola/historia/Capilla de San Ignacio de Loyola.pdf" target="_blank"> FICHA HISTÓRICA - CAPILLA DE SAN IGNACIO</a></td>
                                </tr>
                              </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#teresa" style="color:white">
                    <span>10.</span> SANTA TERESA
                  </h3>
                </div>
                <div id="teresa" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                          <table class="table">
                              <tbody>
                                <tr>
                                  <th scope="row">1</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/ficha/FICHA ARQUITECTONICA 1 SANTA TERESA.pdf" target="_blank"> FICHA ARQUITECTÓNICA SANTA TERESA 1 </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">2</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/ficha/FICHA ARQUITECTONICA 2 SANTA TERESA.pdf" target="_blank"> FICHA ARQUITECTÓNICA SANTA TERESA 2</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">3</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arqueologica/ficha/FICHA ARQUEOLOGICA 1-PLANO.pdf" target="_blank"> FICHA ARQUEOLÓGICA - PLANO SANTA TERESA</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">4</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arqueologica/ficha/FICHA ARQUEOLOGICA 2-FACHADA REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - FACHADA REUTILIZADOS SANTA TERESA</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">5</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arqueologica/ficha/FICHA ARQUEOLOGICA 3-INTERIOR REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - INTERIOR REUTILIZADOS SANTA TERESA</a></td>
                                </tr>


                                <tr>
                                  <th scope="row">6</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 1 SANTA TERESA-CONJUNTO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 1 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">7</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 2 SANTA TERESA-IMAFRONTE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 2 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">8</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 3 SANTA TERESA-FRONTISPICIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 3 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">9</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 6 SANTA TERESA-CUBIERTA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 4 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">10</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7 SANTA TERESA-NAVE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 5 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">11</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7.1 SANTA TERESA-PRESBITERIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 6 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">12</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7.2 SANTA TERESA-CORO Y SOTOCORO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 7 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">13</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7.3 SANTA TERESA-CORO BAJO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 8 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">14</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 8 SANTA TERESA-SACRISTIA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 9 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">15</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9 SANTATERESA PRIMER CLAUSTRO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 10 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">16</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9-1 SANTA TERESA- PRIMER CLAUSTRO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 11 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">17</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9-2 SANTA TERESA-SALA DE PROFUNDIS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 12 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">18</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9.3 SANTA TERESA -CAJA DE ESCALERAS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 13 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">19</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9-4 SANTA TERESA -GALERIAS 1ER NIVEL.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 14 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">20</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9-5 SANTA TERESA -GALERIAS 2DO NIVEL.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 15 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">21</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 10 SANTA TERESA SEGUNDO CLAUSTRO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 16 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">22</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 10-1 SANTA TERESA -GALERIAS 1ER NIVEL.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 17 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">23</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 10-2 SANTA TERESA -GALERIAS 1ER NIVEL-2.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 18 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">24</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 10-3 SANTA TERESA -GALERIAS 2DO NIVEL.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 19 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">25</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 10-4 SANTA TERESA -CAJA DE ESCALERAS 2.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 20 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">26</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 11 SANTA TERESA HUERTO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 21 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">27</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 11-1 SANTA TERESA -E.VALOR.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 22 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">28</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 13 SANTA TERESA -RECIBO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 23 - SANTA TERESA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">29</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arquitectonica/fotografica/FICHA FOTOGRÁFICA 14 SANTA TERESA PATIOS SECUNDARIOS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 24 - SANTA TERESA </a></td>
                                </tr>

                                <tr>
                                  <th scope="row">30</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arqueologica/fotografica/FICHA FOTOGRAFICA 1.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 1 - SANTA TERESA</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">31</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arqueologica/fotografica/FICHA FOTOGRAFICA 2.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 2 - SANTA TERESA</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">32</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arqueologica/fotografica/FICHA FOTOGRAFICA 3.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 3 - SANTA TERESA</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">33</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/arqueologica/fotografica/FICHA FOTOGRAFICA 4.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 4 - SANTA TERESA</a></td>
                                </tr>


                                <tr>
                                  <th scope="row">34</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-teresa/historia/Santa Teresa.pdf" target="_blank"> FICHA HISTÓRICA - SANTA TERESA</a></td>
                                </tr>
                              </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#merced" style="color:white">
                    <span>11.</span> TEMPLO LA MERCED
                  </h3>
                </div>
                <div id="merced" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                          <table class="table">
                              <tbody>
                                <tr>
                                  <th scope="row">1</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/ficha/FICHA ARQUITECTONICA LA MERCED.pdf" target="_blank"> FICHA ARQUITECTÓNICA LA MERCED </a></td>
                                </tr>

                                <tr>
                                  <th scope="row">2</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arqueologica/ficha/FICHA ARQUEOLOGICA 1-PLANO.pdf" target="_blank"> FICHA ARQUEOLÓGICA - PLANO LA MERCED</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">3</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arqueologica/ficha/FICHA ARQUEOLOGICA 2-FACHADA REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - FACHADA REUTILIZADOS LA MERCED</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">4</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arqueologica/ficha/FICHA ARQUEOLOGICA 3-INTERIOR REUTILIZADOS.pdf" target="_blank"> FICHA ARQUEOLÓGICA - INTERIOR REUTILIZADOS LA MERCED</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">5</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arqueologica/ficha/FICHA ARQUEOLOGICA 4-INTERIOR ORIGINAL.pdf" target="_blank"> FICHA ARQUEOLÓGICA - INTERIOR ORIGINAL LA MERCED</a></td>
                                </tr>

                                <tr>
                                  <th scope="row">6</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 1 LA MERCED-CONJUNTO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 1 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">7</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 2 LA MERCED-IMAFRONTE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 2 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">8</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 3 LA MERCED-FRONTISPICIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 3 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">9</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 5 LA MERCED - TORRE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 4 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">10</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 6 LA MERCED - CUBIERTAS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 5 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">11</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7 LA MERCED - NAVE CENTRAL bueno.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 6 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">12</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7.1 LA MERCED - NAVE DE LA EPISTOLA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 7 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">13</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7.2 LA MERCED - NAVE DEL EVANGELIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 8 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">14</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7.3 LA MERCED - PRESBITERIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 9 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">15</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7.4 LA MERCED - CORO Y SOTOCORO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 10 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">16</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7.5 LA MERCED - ANTESACRISTIA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 11 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">17</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 8 LA MERCED - SACRISTIA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 12 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">18</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9 LA MERCED - 1°CLAUSTRO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 13 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">19</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9-1 LA MERCED - GALERIA EO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 14 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">20</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9-2 LA MERCED - GALERIA NS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 15 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">21</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9-3 LA MERCED - ELEMENTOS ARQUITECTONICOS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 16 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">22</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9-4 LA MERCED - CAJA DE ESCALERA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 17 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">23</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9-5 LA MERCED - GALERIAS 2° NIVEL.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 18 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">24</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 10 LA MERCED - 2°CLAUSTRO 1° NIVEL.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 19 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">25</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 10-1 LA MERCED - 2°CLAUSTRO 2° NIVEL.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 20 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">26</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 13 LA MERCED - RECIBO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 21 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">27</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 13-1 LA MERCED - VESTIBULO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 22 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">28</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 15 LA MERCED - REFECTORIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 23 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">29</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 16 LA MERCED - SALA CAPITULAR.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 24 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">30</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 17 LA MERCED - CELDA PADRE SALAMANCA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 25 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">31</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 18 LA MERCED - CUSTODIA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 26 - LA MERCED </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">32</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arquitectonica/fotografica/FICHA FOTOGRÁFICA 19 LA MERCED - DIACONICON.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 27 - LA MERCED </a></td>
                                </tr>

                                <tr>
                                  <th scope="row">33</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arqueologica/fotografica/FICHA FOTOGRAFICA 1.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 1 - LA MERCED</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">34</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arqueologica/fotografica/FICHA FOTOGRAFICA 2.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 2 - LA MERCED</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">35</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arqueologica/fotografica/FICHA FOTOGRAFICA 3.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 3 - LA MERCED</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">36</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/arqueologica/fotografica/FICHA FOTOGRAFICA 4.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUEOLÓGICA 4 - LA MERCED</a></td>
                                </tr>


                                <tr>
                                  <th scope="row">37</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/la-merced/historia/Archivo Fotografico La merced.pdf" target="_blank"> FICHA HISTÓRICA - LA MERCED</a></td>
                                </tr>
                              </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#catedral" style="color:white">
                    <span>12.</span> CATEDRAL
                  </h3>
                </div>
                <div id="catedral" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                          <table class="table">
                              <tbody>
                                <tr>
                                  <th scope="row">1</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/ficha/FICHA ARQUITECTONICA CATEDRAL.pdf" target="_blank"> FICHA ARQUITECTÓNICA CATEDRAL</a></td>
                                </tr>

                                <tr>
                                  <th scope="row">2</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 1 CATEDRAL-CONJUNTO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 1 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">3</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 2 CATEDRAL-IMAFRONTE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 2 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">4</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 3 SANTA CATALINA-FRONTISPICIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 3 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">5</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 4 CATEDRAL-PORTADA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 4 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">6</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 4-2 CATEDRAL-PORTADA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 5 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">7</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 5 CATEDRAL-TORRESS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 6 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">8</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 6 CATEDRAL-CUBIERTAS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 7 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">9</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7 CATEDRAL-NAVE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 8 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">10</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7 LA MERCED - NAVE CENTRAL bueno.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 9 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">11</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-2 CATEDRAL-NAVE DE LA EPISTOLA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 10 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">12</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-3 CATEDRAL-NAVE DE LA EPISTOLA2.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 11 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">13</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-4 CATEDRAL-NAVE DE LA EPISTOLA3.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 12 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">14</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-5 CATEDRAL-NAVE DEL EVANGELIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 13 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">15</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-6 CATEDRAL-NAVE DEL EVANGELIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 14 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">16</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-7 CATEDRAL-TRANSEPTO DEL EVANGELIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 15 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">17</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-8 CATEDRAL-CORO ORGANO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 16 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">18</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-9 CATEDRAL-CORO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 17 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">19</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-10 CATEDRAL-ALTAR.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 18 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">20</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-11 CATEDRAL-NARTEX.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 19 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">21</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-12 CATEDRAL-CRIPTA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 20 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">22</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7.1 CATEDRAL-NAVES LATERALES.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 21 - CATEDRAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">23</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/arquitectonica/fotografica/FICHA FOTOGRÁFICA 8 CATEDRAL-SACRISTIA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 22 - CATEDRAL </a></td>
                                </tr>

                                <tr>
                                  <th scope="row">24</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/catedral/historia/Catedral.pdf" target="_blank"> FICHA HISTÓRICA - CATEDRAL</a></td>
                                </tr>
                              </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#familia" style="color:white">
                    <span>13.</span> CAPILLA DE LA SAGRADA FAMILIA
                  </h3>
                </div>
                <div id="familia" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                          <table class="table">
                              <tbody>
                                <tr>
                                  <th scope="row">1</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/sagrada-familia/arquitectonica/ficha/FICHA ARQUITECTONICA CAPILLA DE LA SAGRADA FAMILIA.pdf" target="_blank"> FICHA ARQUITECTÓNICA CAPILLA DE LA SAGRADA FAMILIA</a></td>
                                </tr>

                                <tr>
                                  <th scope="row">2</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/sagrada-familia/arquitectonica/fotografica/FICHA FOTOGRÁFICA 4 SAGRADA FAMILIA-PORTADA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 1 - CAPILLA DE LA SAGRADA FAMILIA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">3</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/sagrada-familia/arquitectonica/fotografica/FICHA FOTOGRÁFICA 4.1 SAGRADA FAMILIA-PORTADA 2.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 2 - CAPILLA DE LA SAGRADA FAMILIA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">4</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/sagrada-familia/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7 SAGRADA FAMILIA-NAVE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 3 - CAPILLA DE LA SAGRADA FAMILIA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">5</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/sagrada-familia/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7.1 SAGRADA FAMILIA-PRESBITERIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 4 - CAPILLA DE LA SAGRADA FAMILIA </a></td>
                                </tr>


                                <tr>
                                  <th scope="row">6</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/sagrada-familia/historia/Sacra Familia.pdf" target="_blank"> FICHA HISTÓRICA - CAPILLA DE LA SAGRADA FAMILIA</a></td>
                                </tr>
                              </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h3 data-toggle="collapse" data-target="#triunfo" style="color:white">
                    <span>14.</span> TRIUNFO
                  </h3>
                </div>
                <div id="triunfo" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                          <table class="table">
                              <tbody>
                                <tr>
                                  <th scope="row">1</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/triunfo/arquitectonica/ficha/FICHA ARQUITECTONICA 1 TRIUNFO.pdf" target="_blank"> FICHA ARQUITECTÓNICA TRIUNFO</a></td>
                                </tr>

                                <tr>
                                  <th scope="row">2</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/triunfo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 1 TRIUNFO - CONJUNTO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 1 - TRIUNFO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">3</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/triunfo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 2 TRIUNFO-IMAFRONTE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 2 - TRIUNFO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">4</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/triunfo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 3 TRIUNFO - FRONTISPICIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 3 - TRIUNFO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">5</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/triunfo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 6 TRIUNFO - CUBIERTAS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 4 - TRIUNFO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">6</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/triunfo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7 TRIUNFO - NAVE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 5 - TRIUNFO</a></td>
                                </tr>
                                <tr>
                                  <th scope="row">7</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/triunfo/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7.1 TRIUNFO-NAVE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 6 - TRIUNFO</a></td>
                                </tr>

                              </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h3 data-toggle="collapse" data-target="#catalina" style="color:white">
                    <span>15.</span> Santa Catalina
                  </h3>
                </div>
                <div id="catalina" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                          <table class="table">
                              <tbody>
                                <tr>
                                  <th scope="row">1</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/ficha/FICHA ARQUITECTONICA SANTA CATALINA.pdf" target="_blank"> FICHA ARQUITECTÓNICA SANTA CATALINA </a></td>
                                </tr>

                                <tr>
                                  <th scope="row">2</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 1 SANTA CATALINA - CONJUNTO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 1 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">3</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 3 SANTA CATALINA - FRONTISPICIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 2 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">4</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 5 SANTA CATALINA - CUBIERTAS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 3 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">5</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7 SANTA CATALINA - NAVE CENTRAL.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 4 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">6</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-1 SANTA CATALINA - NAVE CENTRAL.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 5 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">7</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-2 SANTA CATALINA - NAVE CENTRAL.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 6 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">8</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-3 SANTA CATALINA - PRESBITERIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 7 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">9</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-5 SANTA CATALINA -CORO ALTO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 8 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">10</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-6 SANTA CATALINA -CORO BAJO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 9 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">11</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-7 SANTA CATALINA -CORO BAJO2.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 10 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">12</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9 SANTA CATALINA - 1ER CLAUSTRO (Autoguardado).pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 11 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">13</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9.1 SANTA CATALINA 1° CLAUSTRO YA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 12 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">14</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9.2 SANTA CATALINA - 1ER CLAUSTRO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 13 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">15</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 10 SANTA CATALINA 2DO CLAUSTRO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 14 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">16</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 12 SANTA CATALINA-HUERTA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 15 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">17</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 15 SANTA CATALINA-REFECTORIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 16 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">18</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 16 SANTA CATALINA-SALA CAPITULAR.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 17 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">19</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 17 SANTA CATALINA MUSEO SALA DE ENTRADA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 18 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">20</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 18 SANTA CATALINA MUSEO-SALA DE LABORES.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 19 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">21</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 18.1 SANTA CATALINA MUSEO-SALA DE LABORES.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 20 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">22</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 19 SANTA CATALINA MUSEO ESTUDIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 21 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">23</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 20 SANTA CATALINA MUSEO-VELATORIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 22 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">24</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 21 SANTA CATALINA MUSEO- REFECTORIO DEL MUSEO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 23 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">25</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 22 SANTA CATALINA MUSEO-NOVICIADO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 24 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">26</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 22.1 SANTA CATALINA MUSEO-NOVICIADO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 25 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">27</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 23 SANTA CATALINA MUSEO-PINACOTECA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 26 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">28</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 23.1 SANTA CATALINA MUSEO-PINACOTECA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 27 - SANTA CATALINA </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">29</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/arquitectonica/fotografica/FICHA FOTOGRÁFICA 24 SANTA CATALINA MUSEO- CELDA DE LA FUNDADORA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 28 - SANTA CATALINA </a></td>
                                </tr>

                                <tr>
                                  <th scope="row">30</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/santa-catalina/historia/Santa Catalina.pdf" target="_blank"> FICHA HISTÓRICA - SANTA CATALINA</a></td>
                                </tr>
                              </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h3 data-toggle="collapse" data-target="#cris" style="color:white">
                    <span>16.</span> San Cristobal
                  </h3>
                </div>
                <div id="cris" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                          <table class="table">
                              <tbody>
                                <tr>
                                  <th scope="row">1</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/ficha/FICHA ARQUITECTONICA SAN CRISTOBAL.pdf" target="_blank"> FICHA ARQUITECTÓNICA SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">2</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 1 SAN CRISTOBAL-CONJUNTO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 1 - SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">3</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 3 SAN CRISTOBAL-FRONTISPICIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 2 - SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">4</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 5 SAN CRISTOBAL-TORRE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 3 - SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">5</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7 SAN CRISTOBAL-NAVE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 4 - SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">6</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7.1 SAN CRISTOBAL-MURO DE LA EPISTOLA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 5 - SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">7</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7.2 SAN CRISTOBAL-CORO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 6 - SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">8</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 8 SAN CRISTOBAL-SACRISTIA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 7 - SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">9</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 17 SAN CRISTOBAL-CAPILLA SAN CRISTOBAL.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 8 - SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">10</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 18 SAN CRISTOBAL-CAPILLA SR. DE LA CAIDA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 9 - SAN CRISTOBAL </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">11</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-cristobal/arquitectonica/fotografica/FICHA FOTOGRÁFICA 19 SAN CRISTOBAL-SR. DE LA FORTALEZA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 10 - SAN CRISTOBAL </a></td>
                                </tr>
                              </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h3 data-toggle="collapse" data-target="#pedro" style="color:white">
                    <span>17.</span> San Pedro
                  </h3>
                </div>
                <div id="pedro" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                          <table class="table">
                              <tbody>
                                <tr>
                                  <th scope="row">1</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-pedro/arquitectonica/ficha/FICHA ARQUITECTONICA 1 SAN PEDRO.pdf" target="_blank"> FICHA ARQUITECTÓNICA SAN PEDRO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">2</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-pedro/arquitectonica/fotografica/FICHA FOTOGRÁFICA 1 SAN PEDRO - CONJUNTO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 1 - SAN PEDRO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">3</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-pedro/arquitectonica/fotografica/FICHA FOTOGRÁFICA 2 SAN PEDRO-IMAFRONTE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 2 - SAN PEDRO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">4</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-pedro/arquitectonica/fotografica/FICHA FOTOGRÁFICA 3 SAN PEDRO - FRONTISPICIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 3 - SAN PEDRO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">5</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-pedro/arquitectonica/fotografica/FICHA FOTOGRÁFICA 5 SAN PEDRO -TORRE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 4 - SAN PEDRO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">6</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-pedro/arquitectonica/fotografica/FICHA FOTOGRÁFICA 6 SAN PEDRO - CUBIERTAS.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 5 - SAN PEDRO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">7</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-pedro/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7 SAN PEDRO - NAVE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 6 - SAN PEDRO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">8</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-pedro/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-1 SAN PEDRO-NAVE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 7 - SAN PEDRO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">9</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-pedro/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7-5 SAN PEDRO - CORO Y SOTOCORO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 8 - SAN PEDRO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">10</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-pedro/arquitectonica/fotografica/FICHA FOTOGRÁFICA 8 SAN PEDRO - SACRISTIA.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 9 - SAN PEDRO </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">11</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-pedro/historia/San Pedro.pdf" target="_blank"> FICHA HISTÓRICA - SAN PEDRO</a></td>
                                </tr>
                              </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h3 data-toggle="collapse" data-target="#blas" style="color:white">
                    <span>18.</span> San Blas
                  </h3>
                </div>
                <div id="blas" class="collapse" data-parent="#accordionOne">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                          <table class="table">
                              <tbody>
                                <tr>
                                  <th scope="row">1</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-blas/arquitectonica/ficha/FICHA ARQUITECTONICA SAN BLAS.pdf" target="_blank"> FICHA ARQUITECTÓNICA SAN BLAS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">2</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-blas/arquitectonica/fotografica/FICHA FOTOGRÁFICA 1 SAN BLAS - CONJUNTO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 1 - SAN BLAS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">3</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-blas/arquitectonica/fotografica/FICHA FOTOGRÁFICA 2 SAN BLAS - IMAFRONTE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 2 - SAN BLAS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">4</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-blas/arquitectonica/fotografica/FICHA FOTOGRÁFICA 3 SAN BLAS - FRONTISPICIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 3 - SAN BLAS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">5</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-blas/arquitectonica/fotografica/FICHA FOTOGRÁFICA 5 SAN BLAS - TORRE.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 4 - SAN BLAS </a></td>
                                </tr>

                                <tr>
                                  <th scope="row">6</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-blas/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7 SAN BLAS - NAVE CENTRAL.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 5 - SAN BLAS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">7</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-blas/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7.1 SAN BLAS - NAVE DE LA EPISTOLA Y DEL EVANGELIO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 6 - SAN BLAS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">8</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-blas/arquitectonica/fotografica/FICHA FOTOGRÁFICA 7.5 SAN BLAS - CORO Y SOTOCORO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 7 - SAN BLAS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">9</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-blas/arquitectonica/fotografica/FICHA FOTOGRÁFICA 9 SAN BLAS - PATIO TESTERO.pdf" target="_blank"> FICHA FOTOGRÁFICA ARQUITECTÓNICA 8 - SAN BLAS </a></td>
                                </tr>
                                <tr>
                                  <th scope="row">10</th>
                                  <td><a href="assets/pdf/inmuebles-religiosos/san-blas/historia/San Blas.pdf" target="_blank"> FICHA HISTÓRICA - SAN BLAS</a></td>
                                </tr>
                              </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
